// src/components/DetailSection.tsx
import * as React from "react"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { cn } from "@/lib/utils"
import { Copy } from "lucide-react"

export interface DetailRow {
  label: string
  value?: React.ReactNode
  copyable?: boolean
  copyValue?: string  // expliziter Clipboard-Text wenn value kein string ist
}

export interface DetailSectionProps {
  title?: string
  rows: DetailRow[]
  className?: string
}

export function DetailSection({ title, rows, className }: DetailSectionProps) {
  const handleCopy = (row: DetailRow) => {
    const text = row.copyValue ?? (typeof row.value === 'string' || typeof row.value === 'number' ? String(row.value) : '')
    navigator.clipboard.writeText(text).catch(() => {
      // Silently ignore clipboard errors
    })
  }

  return (
    <Card className={cn(className)}>
      {title && (
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
      )}
      <CardContent>
        <div className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2">
          {rows.map((row, index) => (
            <React.Fragment key={index}>
              <span className="text-sm text-muted-foreground font-medium">
                {row.label}
              </span>
              <span className="text-sm flex items-center gap-1.5">
                {row.value ?? "—"}
                {row.copyable && row.value != null && (
                  <button
                    type="button"
                    onClick={() => handleCopy(row)}
                    className="inline-flex items-center justify-center text-muted-foreground hover:text-foreground transition-colors flex-shrink-0"
                    aria-label={`${row.label} kopieren`}
                  >
                    <Copy className="h-3.5 w-3.5" />
                  </button>
                )}
              </span>
            </React.Fragment>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
